import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export {
  Container,
};
